export default "__VITE_ASSET__drupnKn7__ 720w";